import { render, staticRenderFns } from "./SavedSearches.vue?vue&type=template&id=45acb3b0"
import script from "./SavedSearches.vue?vue&type=script&lang=js"
export * from "./SavedSearches.vue?vue&type=script&lang=js"
import style0 from "./SavedSearches.vue?vue&type=style&index=0&id=45acb3b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports